"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.castToKeywordMatchType = exports.KeywordMatchTypeSchema = exports.KeywordMatchType = exports.TagSchema = exports.KeywordSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../core");
const cast_1 = require("../utils/cast");
exports.KeywordSchema = typebox_1.Type.String({
    minLength: 1,
    maxLength: 128,
    title: "Keyword",
    description: "Keyword for match",
    examples: ["term", "theme"],
});
exports.TagSchema = typebox_1.Type.String({
    minLength: 1,
    maxLength: 32,
    title: "Tag",
    description: "Tag name for keyword",
    examples: ["brand", "money"],
});
var KeywordMatchType;
(function (KeywordMatchType) {
    KeywordMatchType["EXACT"] = "E";
    KeywordMatchType["BROAD"] = "B";
})(KeywordMatchType = exports.KeywordMatchType || (exports.KeywordMatchType = {}));
exports.KeywordMatchTypeSchema = (0, core_1.StringUnion)([KeywordMatchType.EXACT, KeywordMatchType.BROAD], {
    title: "Keyword Match",
    description: "Determines flexibility in keyword matching",
});
exports.castToKeywordMatchType = (0, cast_1.castToEnum)(KeywordMatchType);
